import { Row } from "antd";
import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { TELEGRAM_GROUPS } from "../shared/constants";

interface Props {
  withoutTitle?: boolean;
  small?: boolean;
}

const Icon = styled.div<Props>`
  svg {
    fill: #fff;
    width: ${(props) => (props.small ? "15px" : "25px")};
    height: ${(props) => (props.small ? "15px" : "25px")};
  }

  &:hover svg {
    fill: white;
  }

  a {
    display: flex;
    justify-content: center;
    align-items: center;
    border: 2px solid #fff;
    padding: ${(props) => (props.small ? "8px" : "14px")};
    margin-left: 8px;
    margin-right: 8px;
    border-radius: 80px;
    transition: all 0.5s ease;
  }

  a.facebook:hover {
    background: #29487d;
    border: none;
  }

  a.insta:hover {
    background: #f09433;
    border: none;
    background: -moz-linear-gradient(
      45deg,
      #f09433 0%,
      #e6683c 25%,
      #dc2743 50%,
      #cc2366 75%,
      #bc1888 100%
    );
    background: -webkit-linear-gradient(
      45deg,
      #f09433 0%,
      #e6683c 25%,
      #dc2743 50%,
      #cc2366 75%,
      #bc1888 100%
    );
    background: linear-gradient(
      45deg,
      #f09433 0%,
      #e6683c 25%,
      #dc2743 50%,
      #cc2366 75%,
      #bc1888 100%
    );
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#f09433', endColorstr='#bc1888', GradientType=1);
  }

  a.telegram:hover {
    background: #288ec9;
    border: none;
  }

  a.tiktok:hover {
    background: black;
    border: none;
  }
`;

const FooterSocial: FC<Props> = ({ withoutTitle = false, small = false }) => {
  const { i18n } = useTranslation();

  return (
    <Row justify="center" align="middle">
      <Icon small={small}>
        <a
          rel="noreferrer"
          href="https://www.facebook.com/wealthclubvip"
          className="facebook"
          target="_blank"
        >
          <svg
            data-name="mk-icon-facebook"
            data-cacheid="icon-5cb35c89e7ba1"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 1024 1792"
          >
            <path d="M959 12v264h-157q-86 0-116 36t-30 108v189h293l-39 296h-254v759h-306v-759h-255v-296h255v-218q0-186 104-288.5t277-102.5q147 0 228 12z"></path>
          </svg>
        </a>
      </Icon>
      <Icon small={small}>
        <a
          rel="noreferrer"
          href="https://www.facebook.com/groups/wealthclubvip"
          className="facebook"
          target="_blank"
        >
          <svg
            data-name="mk-icon-facebook"
            data-cacheid="icon-5cb35c89e7ba1"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 1024 1792"
          >
            <path d="M959 12v264h-157q-86 0-116 36t-30 108v189h293l-39 296h-254v759h-306v-759h-255v-296h255v-218q0-186 104-288.5t277-102.5q147 0 228 12z"></path>
          </svg>
        </a>
      </Icon>
      <Icon small={small}>
        <a
          rel="noreferrer"
          href="https://www.instagram.com/wealthclubvip"
          className="insta"
          target="_blank"
        >
          <svg
            data-name="mk-icon-instagram"
            data-cacheid="icon-5cb35c89e9b1d"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 1792 1792"
          >
            <path d="M1152 896q0-106-75-181t-181-75-181 75-75 181 75 181 181 75 181-75 75-181zm138 0q0 164-115 279t-279 115-279-115-115-279 115-279 279-115 279 115 115 279zm108-410q0 38-27 65t-65 27-65-27-27-65 27-65 65-27 65 27 27 65zm-502-220q-7 0-76.5-.5t-105.5 0-96.5 3-103 10-71.5 18.5q-50 20-88 58t-58 88q-11 29-18.5 71.5t-10 103-3 96.5 0 105.5.5 76.5-.5 76.5 0 105.5 3 96.5 10 103 18.5 71.5q20 50 58 88t88 58q29 11 71.5 18.5t103 10 96.5 3 105.5 0 76.5-.5 76.5.5 105.5 0 96.5-3 103-10 71.5-18.5q50-20 88-58t58-88q11-29 18.5-71.5t10-103 3-96.5 0-105.5-.5-76.5.5-76.5 0-105.5-3-96.5-10-103-18.5-71.5q-20-50-58-88t-88-58q-29-11-71.5-18.5t-103-10-96.5-3-105.5 0-76.5.5zm768 630q0 229-5 317-10 208-124 322t-322 124q-88 5-317 5t-317-5q-208-10-322-124t-124-322q-5-88-5-317t5-317q10-208 124-322t322-124q88-5 317-5t317 5q208 10 322 124t124 322q5 88 5 317z"></path>
          </svg>
        </a>
      </Icon>
      <Icon small={small}>
        <a
          rel="noreferrer"
          href="https://www.tiktok.com/@wealthclubvip"
          className="tiktok"
          target="_blank"
        >
          <svg
            data-name="mk-icon-tiktok"
            data-cacheid="icon-5cb389e9341b1d"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 2859 3333"
            shapeRendering="geometricPrecision"
            textRendering="geometricPrecision"
            imageRendering="optimizeQuality"
            fillRule="evenodd"
            clipRule="evenodd"
          >
            <path d="M2081 0c55 473 319 755 778 785v532c-266 26-499-61-770-225v995c0 1264-1378 1659-1932 753-356-583-138-1606 1004-1647v561c-87 14-180 36-265 65-254 86-398 247-358 531 77 544 1075 705 992-358V1h551z" />
          </svg>
        </a>
      </Icon>
      <Icon small={small}>
        <a
          rel="noreferrer"
          href={TELEGRAM_GROUPS[i18n.language]}
          className="telegram"
          target="_blank"
        >
          <svg
            data-name="mk-icon-telegram"
            data-cacheid="icon-5cb35c89341b1d"
            viewBox="0 -31 512 512"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="m123.195312 260.738281 63.679688 159.1875 82.902344-82.902343 142.140625 112.976562 100.082031-450-512 213.265625zm242.5-131.628906-156.714843 142.941406-19.519531 73.566407-36.058594-90.164063zm0 0" />
          </svg>
        </a>
      </Icon>
    </Row>
  );
};

export default FooterSocial;
